import { Component, Input } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { rackFormField } from "./rack-form-field.form";
import { Subscription } from "rxjs";
import { ModalService } from "src/services/modal/modal.service";
import { ScanRackModalComponent } from "../../scanner/rack-scanner/modal/scan-rack-modal.component";
import { isRack, normalizeRack, Rack, rackToString } from "src/services/item/rack.interface";
import { BaseFormObjectComponent } from "../base-form-object.component";
import { getBayOptions, getCityOptions, getNumberOptions, getRowOptions } from "src/services/item/item.utils";
import { BaseLocation } from "src/services/subscription/base-locations.enum";

@Component({
  selector: "rc-rack-form-field",
  templateUrl: "./rack-form-field.component.html",
  styleUrls: ["./rack-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: RackFormFieldComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: RackFormFieldComponent,
    },
  ],
  standalone: false,
})
export class RackFormFieldComponent extends BaseFormObjectComponent<Rack> {
  @Input() showScannerButton: boolean;

  public onChangeSubs: Subscription[] = [];
  public form = this.formBuilder.group({
    [rackFormField.bay]: new FormControl<string | null>(null),
    [rackFormField.city]: new FormControl<BaseLocation | null>(null),
    [rackFormField.number]: new FormControl<string | null>(null),
    [rackFormField.row]: new FormControl<string | null>(null),
  });

  public constructor(
    private readonly formBuilder: FormBuilder,
    private readonly modalService: ModalService,
  ) {
    super();
  }

  public rackRequiredValidator(control: AbstractControl) {
    const rack = control.value as Rack;

    const values = [rack?.bay, rack?.row, rack?.number];

    if (values.every((x) => !!x) || values.every((x) => !x)) {
      return null;
    } else {
      return { rackIncomplete: true };
    }
  }

  public async onInputChange(event: Partial<Rack>): Promise<void> {
    if (!event || !isRack(event)) {
      return;
    }

    await super.onInputChange(event);
  }

  public validate(control: AbstractControl): object | null {
    return this.rackRequiredValidator(control);
  }

  public async showScanModal(): Promise<void> {
    const modal = await this.modalService.presentModal(ScanRackModalComponent, {});

    const rack = (await modal.onDidDismiss<Rack>()).data;

    if (!rack || !isRack(rack)) {
      return;
    }

    this.form.patchValue({ ...normalizeRack(rack) });
  }

  protected toDisplayValue(input: Rack): string {
    return rackToString(input);
  }

  public readonly rackFormField = rackFormField;
  public readonly getBayOptions = getBayOptions;
  public readonly getRowOptions = getRowOptions;
  public readonly getNumberOptions = getNumberOptions;
  public readonly getCityOptions = getCityOptions;
}
